import { Component } from "@angular/core";
import { FieldType, FieldArrayType } from "@kre-form/core";
import { KreFormAntService } from "../tools/service";

@Component({
  selector: "krefield-anchor",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <nz-divider
        class="control-design"
        [id]="field.key"
        [nzText]="to.description"
      ></nz-divider>
      <!-- <div id="components-anchor-demo-basic" style="height: 400px;">1</div> -->
    </ng-container>

    <ng-template #other>
      <nz-divider
        class="control-design"
        [id]="field.key"
        [nzText]="to.description"
      ></nz-divider>
      <!-- <div id="components-anchor-demo-basic" style="height: 400px;">1</div> -->
    </ng-template>
  `,
})
export class KreFormFieldAnchor extends FieldType {}
